<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "4rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64"><path d="M47.12 26.6v-6.27a15.11 15.11 0 10-30.22 0v6.28H15a2 2 0 00-2 2V57.1a2 2 0 002 2h34a2 2 0 002-2V28.6a2 2 0 00-2-2zM48 56.1H16V29.6h3.85v-9.27a12.11 12.11 0 1124.22 0v9.27H48z"/><path d="M32 11.1a9.07 9.07 0 00-9 9.14v9.36h18v-9.36a9.07 9.07 0 00-9-9.14zm6 15.5H26v-6.36a6 6 0 1112 0zM32 32.1a7 7 0 00-7 7 6.91 6.91 0 001.57 4.41l-1.48 5.85A3 3 0 0028 53.1h8a3 3 0 002.36-1.16 3 3 0 00.55-2.58l-1.49-5.85A6.92 6.92 0 0039 39.1a7 7 0 00-7-7zm4 18h-8l1.92-7.6a4 4 0 114.15 0z"/></svg>